import { API_DRIVE_PREFIX, SuiteApiClient } from "@weco/suite-client";

export const driveApi = new SuiteApiClient(API_DRIVE_PREFIX);
